import {createSlice, current} from "@reduxjs/toolkit";
import {CurrentEvent} from "../../models/CurrentEvent";

/**
 * Current Event Slice
 * - Takes in current event objects in db format
 * (i.e. sensor_id, update_time, etc.)
 * - Stores current event objects in frontend format
 * (i.e. sensorId, updateTime, etc.)
 * - stores data as dict of dict:
 * data: { sensorId1: {CurrentEvent obj 1},
 *         sensorId2: {CurrentEvent obj 2},
 *         ...
 *       }
 * reference: { authorizedRoomId1: true,
 *              authorizedRoomId2: true,
 *              ...
 *            }
 */
const initialState = {
  loading: false,
  data: {},
  reference: {},
  error: "",
};

const currentEventSlice = createSlice({
  name: "currentEvent",
  initialState,

  reducers: {
    /**
     * Add current event if sensor is accessible by user
     */
    addCurrentEvent: (state, action) => {
      let newCurrEvent = JSON.parse(
        JSON.stringify(new CurrentEvent(action.payload))
      );
      let key = newCurrEvent.sensorId;
      let rid = newCurrEvent.roomId;

      if (!state.reference[rid]) return;
      state.data[key] = newCurrEvent;
    },
    updateCurrentEvent: (state, action) => {
      let key = action.payload.sensor_id;
      if (!state.data[key]) return;
      state.data[key].updateTime = action.payload.update_time;
      let status = action.payload.status;
      let message = action.payload.message;
      if (status) {
        state.data[key].status = status;
      }
      if (message) {
        state.data[key].message = message;
      }
    },
    deleteCurrentEvent: (state, action) => {
      const key = action.payload.sensor_id;
      if (!state.data[key]) return;
      delete state.data[key];
    },
    setCurrentEvent: (state, action) => {
      let eventList = action.payload;
      let displayDict = {};
      for (let event of eventList) {
        event = JSON.parse(JSON.stringify(new CurrentEvent(event)));
        displayDict[event.sensorId] = event;
      }
      state.data = displayDict;
    },
    checkIn: (state, action) => {
      let roomChecked = action.payload.roomChecked;
      let time = action.payload.checkInTime;
      let copy = current(state.data);

      for (let key in state.data) {
        if (copy[key].roomId === roomChecked) {
          state.data[key].checkInTime = time;
        }
      }
    },
    setEventReference: (state, action) => {
      let roomList = action.payload;
      let copy = {};
      for (let room of roomList) {
        copy[room.room_id] = true;
      }
      state.reference = copy;
    },
  },
});

export const {
  setCurrentEvent,
  addCurrentEvent,
  updateCurrentEvent,
  deleteCurrentEvent,
  checkIn,
  setEventReference,
} = currentEventSlice.actions;

export default currentEventSlice.reducer;
